import React, { Component } from "react";
import ReactChart from "js/react/components/ReactChart";
import { FetchStatus } from "js/react/constants";
import { formatter } from "../../../../../common/formatter";
import AnalyticsController from "js/react/views/Analytics/AnalyticsController";
import { t } from "js/i18n";

class SessionDetail extends Component {
    componentWillMount() {
        AnalyticsController.fetchSessionData(
            this.props.analytics.selectedLink.selectedSessionId
        );
    }

    render() {
        let selectedLink = this.props.analytics.selectedLink;

        let status = selectedLink.sessionDetail
            ? selectedLink.sessionDetail.status
            : { type: FetchStatus.LOADING };

        let series, categories;
        if (selectedLink.sessionDetail && selectedLink.sessionDetail.data) {
            let sips = this.props.presentation.getSips();
            series = [
                {
                    type: "column",
                    name: t("Seconds"),
                    data: sips
                        .map(slideId =>
                            selectedLink.sessionDetail.data.find(
                                row => row.slideid === slideId
                            )
                        )
                        .map(row => (row ? Math.round(row.sum / 1000) : null)),
                    tooltip: {
                        headerFormat: "",
                        pointFormatter: function() {
                            const label = formatter.formatDuration(
                                this.y,
                                "seconds",
                                "h [hrs] m [mins] s [secs]"
                            );
                            return [
                                "<span style='font-size: 10px; color: #333'>",
                                t("Slide {{number}}", { number: this.x + 1 }),
                                "</span><br/><span style='font-size: 12px; color: #333; font-weight: bold'>",
                                label,
                                "</span>"
                            ].join("");
                        }
                    }
                }
            ];
            categories = sips.map((slideId, i) => i + 1);
        }

        return (
            <div className="chart-panel">
                <label>{t("Time per slide")}</label>
                <ReactChart
                    status={status}
                    series={series}
                    categories={categories}
                    height={200}
                    yAxisTitle={t("SECONDS")}
                />
            </div>
        );
    }
}

export default AnalyticsController.withState(SessionDetail);
